<template>
    <v-dialog
    v-model="dialog"                
    max-width="850px"
    :fullscreen="isFullscreen"
    persistent
    >        
        <v-card>
            <v-btn class="mx-2 btnleft" 
            :disabled="editedIndex-1 < 0"
            @click="save(true,previous)" 
            fab dark small color="primary">
                <v-icon dark>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn class="mx-2 btnright" 
            :disabled="editedIndex+1 >= items.length"
            @click="save(true,next)" fab dark small color="primary">
                <v-icon dark>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn class="mx-2 btncancel" 
            :disabled="editedIndex+1 >= items.length"
            @click="close" fab dark small color="secondary">
                <v-icon dark>cancel</v-icon>
            </v-btn>
            <v-btn class="mx-2 btnsave" 
            :disabled="editedIndex+1 >= items.length"
            @click="save(true,getItems)" fab dark small color="primary">
                <v-icon dark>save</v-icon>
            </v-btn>
            <v-card-title
            class="grey lighten-2 stickyHeader"
            primary-title
            >
            <v-layout>
                <v-flex xs8>
                {{this.dialogData.title}}    <br> 
                <span class="grey--text">{{this.dialogData.code}}</span> <br>
                <div v-if="editedItems[0].PVPR" style="display: inline-flex "><span class="grey--text bold-text">PVPR - {{editedItems[0].PVPR}}€ &nbsp;&nbsp;&nbsp;</span></div>
                <div v-if="editedItems[0].PVPRM" style="display: inline-flex "><span class="grey--text bold-text">PVPMR - {{editedItems[0].PVPRM}}€</span></div>
                {{availabilityListVisible}}
                <v-btn v-if="$store.state.usuario.type == 'COMERCIAL'" @click="availabilityListVisible = !availabilityListVisible;">
                    <v-icon class="grey--text">list</v-icon><span class="grey--text">Disponible: {{this.totalAvailable}} </span> <br>
                </v-btn>
                <availabilityList v-if="availabilityListVisible"/>
                </v-flex>
            </v-layout>                                         
            </v-card-title>                            
            <v-card-text style="padding-top: 82px;">                                                                          
                <v-layout>
                    <promocionesArticulo v-if="$store.state.appconfig.promociones"/>                
                </v-layout>
                <v-layout>
                    <descuentosArticulo v-if="editedItems[0].descuentos && editedItems[0].descuentos.length != 0"/>
                </v-layout>
            </v-card-text>
            <v-img 
            :src="this.dialogData.picture"
            :lazy-src="this.dialogData.pictureLazy"
            contain
            :max-height="maxImgHeight"
            >
            </v-img>

            <v-divider></v-divider>

            <v-card-text>
                <v-container grid-list-md pa-0>   

                    <!--DT 11545 <div v-if="($store.state.tipoDocumento != 'abono') || (($route.name != 'pedido') && ($store.state.tipoDocumento == 'abono'))">-->
                    <div>
                        <div v-if="$store.state.usuario.type == 'COMERCIAL'">
                            <span v-if="sameNoItems.length">Nuevo</span>
                            <v-icon
                            v-if="/*editedItems[0].trackingEnabled || (($store.state.tipoDocumento == 'abono') && (editedItems[0].ItemTrackingCode == 'LOT+CAD'))*/true"
                                medium
                                @click="addNew()"                        
                            >
                                add
                            </v-icon>
                        </div>
                    <ul>
                        <li v-for="error in errors" :key="error.id">
                            <v-alert :value="true" color="error" icon="warning"> {{ error.msg }}
                            </v-alert>      
                        </li>                  
                    </ul>
                    <!--span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors[.first('dto')] }}</v-alert> </span>                   
                    <span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors.first('cantidad') }}</v-alert> </span>                   
                    <span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors.first('precio') }}</v-alert> </span-->
                    <v-layout 
                    v-for="(editedItem, index) in editedItems"
                    :key="'new'+editedItem.No+index"
                    wrap>                                             
                        <v-flex xs6 sm3 md2>
                            <v-text-field v-model="editedItem.cantidad" type="number" label="Cantidad" @focus.stop="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>                        
                        </v-flex>                        
                        <v-flex xs6 sm2 md2
                        v-if="$store.state.appconfig.allowUOMS" >
                            <v-select
                                :items="editedItem.uoms"
                                item-text="code"
                                item-value="code"
                                label="UD"
                                v-model="editedItem.uom"
                            ></v-select>
                        </v-flex>   
                        <v-flex xs6 sm2 md2
                        v-if="editedItem.trackingEnabled && ($store.state.tipoDocumento != 'abono')" >
                            <v-select
                                :items="editedItem.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItem.lote"
                            ></v-select>
                        </v-flex>  
                        <v-flex xs6 sm2 md2
                        v-if="(($store.state.tipoDocumento == 'abono') && (editedItem.ItemTrackingCode == 'LOT+CAD'))" >
                            <v-autocomplete
                                :items="editedItem.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItem.lote"
                            ></v-autocomplete>
                        </v-flex>  
                        <v-flex xs6 sm2 md2 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.precio" type="number" label="Precio" @focus.stop="$event.target.select()" @change="editedItem.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm2 md2 v-if="!$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.precio" type="number" label="Precio" v-validate="'min_value:0'" name="precio" readonly></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm3 md2 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.descuento" type="number" label="Descuento" @focus.stop="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>   
                        <v-flex xs6 sm2 md3 class="priceTag">
                            {{editedItem.precio}}€/u | {{editedItem.vatPct}}% | {{importeLinea(editedItem,$store.state.tipoDocumento == 'abono',$store.state.appconfig.showVAT)}} €
                        </v-flex>                                 
                    </v-layout>  
                    </div>
                    <div v-if="$store.state.usuario.type == 'COMERCIAL'">
                    <span v-if="sameNoItems.length">En pedido</span>                      
                    <v-layout 
                    v-for="(item, index) in sameNoItems"
                    :key="item.No+index"
                    wrap>
                        <v-flex xs6 sm4 md2>
                            <v-text-field v-model="item.cantidad" label="Cantidad" @focus.stop="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm2 md2
                        v-if="$store.state.appconfig.allowUOMS" >
                            <v-select
                                :items="item.uoms"
                                item-text="code"
                                item-value="code"
                                label="UD"
                                v-model="item.uom"
                            ></v-select>
                        </v-flex> 
                        <!--v-flex xs5 sm3 md2 v-if="$store.state.tipoDocumento != 'abono'">
                            <v-autocomplete
                                :items="item.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="item.lote"
                            ></v-autocomplete>
                        </v-flex>    
                        <v-flex xs6 sm2 md2
                        v-else-if="(($store.state.tipoDocumento == 'abono') && (item.ItemTrackingCode == 'LOT+CAD'))" >
                            <v-autocomplete
                                :items="item.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="item.lote"
                            ></v-autocomplete>
                        </v-flex-->  
                        <v-flex xs6 sm2 md2 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="item.precio" type="number" label="Precio" @focus.stop="$event.target.select()" @change="item.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm2 md2 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="item.descuento" type="number" label="Descuento" @focus.stop="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm2 md3 class="priceTag">
                            {{item.precio}}€/u | {{item.vatPct}}% | {{importeLinea(item,$store.state.tipoDocumento == 'abono',$store.state.appconfig.showVAT)}} €
                        </v-flex>   
                         
                        <v-flex xs1 sm1 md1>
                        <v-icon
                            small
                            right=""                            
                            @click="deleteItem(item)"
                        >
                            delete
                        </v-icon> 
                        </v-flex>                                        
                    </v-layout>    
                    </div>                       
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary darken-1" flat @click="close">Cancelar</v-btn>
                <v-btn color="primary darken-1" flat @click="save(true,getItems)">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>   
</template>
<script>
import promocionesArticulo from '@/components/promocionesArticulo'
import descuentosArticulo from '@/components/descuentosArticulo'
import availabilityList from '@/components/availabilityList'
import { formatDate } from '@fullcalendar/vue'
export default {    
    name: 'dialogEditItemMobile',
    components:{
        promocionesArticulo,
        availabilityList,
        descuentosArticulo
    },
    data: function () {
        return {
            
        }
    },
    methods:{
        importeLinea(item,abono,vat)                                             {
            var res = 0;
            if (item.descuento == undefined)
                item.descuento = 0;
            if (item.cantidad > 0){
                res = ((item.precioUnit * item.cantidad) - ((item.precioUnit * item.cantidad)*(item.descuento/100))); 
                var tILT = item.importeILT * item.cantidad * parseFloat(item.qtyperuom);
                res = parseFloat(res) * parseFloat(item.qtyperuom);
                res += tILT;
                if (vat){
                    var igic = ((parseFloat(item.prodPostingGroup)/100)*parseFloat(res));
                    if (Number(igic)){
                        res = parseFloat(res) + parseFloat(igic);            
                    } 
                }
                if (item.descuento == 100){
                    res = 0;
                }
            }
            if (abono)
                return (this.decimalAdjust('round', res, -2) * -1).toFixed(2);
            else
                return this.decimalAdjust('round', res, -2).toFixed(2);
        },
        imageLoadError (index) {
            //console.log('Image failed to load');            
            var file = require('../assets/noimage.png');            
            this.dialogData.picture = file;
        },
        loteCaption(item){
            if(item.caducidad != ''){
                var date = item.caducidad.split('T');
                date = this.formatDate(date[0]);                
                return item.lote + '(' + item.disponible + ') - ' + date;
            } else {                
                return item.lote + '(' + item.disponible + ')';
            }            
        },  
        close () {
            //if (this.editedItems[0].trackingEnabled || ((this.$store.state.tipoDocumento == 'abono') && (this.editedItems[0].ItemTrackingCode == 'LOT+CAD'))){
                //Este codigo es para descartar los cambios en las lineas de pedido al darle a cerrar.
                //sameNoItems viene de una operacion .filter sobre un array, por lo que el tipo de copia es shallow copy,
                //actualizando los valores de sameNoItems se actualizan los valores en la lista de productos sin necesidad de 
                //codigo adicional.
                //Si la edicion se cancela, hay que restaurar los valores editados
                for (var i = 0; i < this.sameNoItems.length; i++){
                    this.sameNoItems[i].cantidad = this.sameNoItemsBackup[i].cantidad;
                    this.sameNoItems[i].precio = this.sameNoItemsBackup[i].precio;
                    this.sameNoItems[i].descuento = this.sameNoItemsBackup[i].descuento;
                    this.sameNoItems[i].lote = this.sameNoItemsBackup[i].lote;
                    this.sameNoItems[i].uom = this.sameNoItemsBackup[i].uom;
                }
            //}
            this.dialog = false        
        },
        save (closeDialog,callback) {      
            var ok = true;              
            //this.editedItem.lote = this.lotSelection;
            //Object.assign(this.items[this.editedIndex], this.editedItem);
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {
                    //if (this.editedItems[0].trackingEnabled || ((this.$store.state.tipoDocumento == 'abono') && (this.editedItems[0].ItemTrackingCode == 'LOT+CAD'))){
                        console.log(this.editedItems);
                        console.log(this.sameNoItems);
                        for (var i = 0; i < this.editedItems.length; i++){            
                           /* if (!this.editedItems[i].lote){
                                if (this.editedItems[i].cantidad){
                                    this.setGlobalDialog('Lote requerido','No ha introducido lote para el producto ' + this.editedItems[i].No,false);
                                    return;
                                }
                            } else {
                                var resLote = this.editedItems[i].lotes.find(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });
                                if (resLote.length == undefined) resLote = [resLote];
                                //var orderQty = parseFloat(this.editedItems[i].cantidad);     
                                var orderQty = 0;
                                //Control de cantidad sobre lineas a insertar
                                var res = this.editedItems.filter(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });   
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                //Control de cantidad en otras lineas en pedido               
                                var res = this.sameNoItems.filter(itm =>{
                                    return itm.lote == this.editedItems[i].lote;
                                });        
                                if (res != undefined) {
                                    if (res.length == undefined) res = [res];            
                                    for (var j = 0; j < res.length; j++){
                                        orderQty += parseFloat(res[j].cantidad);
                                    }
                                }
                                if (parseFloat(resLote[0].disponible) < orderQty){
                                    this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.editedItems[i].lote + ' (' + resLote[0].disponible + ')',false);
                                    return;
                                }                    
                            }*/
                            /*
                            if ((this.editedItems[i].precio == 0) && (this.editedItems[i].descuento != 100)){
                                this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.editedItems[i].No ,false);
                                return;
                            }*/           
                            this.items[this.editedIndex].cantidad = this.editedItems[0].cantidad;
                            //Fix para que si quedan cantidades a 0 no borre alguna linea ya cargada
                            if (this.$store.state.usuario.type == 'COMERCIAL'){
                                var sameRes = this.sameNoItems.filter(itm=>{
                                    return (itm.No == this.editedItems[i].No) && (itm.lote == this.editedItems[i].lote) && (itm.precio == this.editedItems[i].precio) && (itm.descuento == this.editedItems[i].descuento);
                                });
                                if (sameRes.length == 0){
                                    this.commitToCart(this.editedItems[i],false);
                                } else {
                                    sameRes[0].cantidad = parseFloat(sameRes[0].cantidad) + parseFloat(this.editedItems[i].cantidad);
                                }
                            } else {
                                this.commitToCart(this.editedItems[i],false);
                            }
                        }
                        if (this.$store.state.usuario.type == 'COMERCIAL'){
                            for (var i = 0; i < this.sameNoItems.length; i++){
                                /*if (!this.sameNoItems[i].lote) {
                                    this.setGlobalDialog('Lote requerido','No ha introducido lote para el producto ' + this.sameNoItems[i].No,false);
                                    return;
                                } else {
                                    resLote = this.sameNoItems[i].lotes.find(itm =>{
                                        return itm.lote == this.sameNoItems[i].lote;
                                    });
                                    if (resLote.length == undefined) resLote = [resLote];
                                    var orderQty = 0;      // Se inicializa a 0 porque el filter ya devuelve este mismo producto del bucle
                                    //Control de cantidad sobre lineas a insertar
                                    var res = this.editedItems.filter(itm =>{
                                        return itm.lote == this.sameNoItems[i].lote;
                                    });   
                                    if (res != undefined) {
                                        if (res.length == undefined) res = [res];            
                                        for (var j = 0; j < res.length; j++){
                                            orderQty += parseFloat(res[j].cantidad);
                                        }
                                    }
                                    //Control de cantidad en otras lineas               
                                    var res = this.sameNoItems.filter(itm =>{
                                        return itm.lote == this.sameNoItems[i].lote;
                                    });        
                                    if (res != undefined) {
                                        if (res.length == undefined) res = [res];            
                                        for (var j = 0; j < res.length; j++){
                                            orderQty += parseFloat(res[j].cantidad);
                                        }
                                    }
                                    if (parseFloat(resLote[0].disponible) < orderQty){
                                        this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.sameNoItems[i].lote + ' (' + resLote[0].disponible + ')',false);
                                        return;
                                    }
                                }
                                if ((this.sameNoItems[i].precio == 0) && (this.sameNoItems[i].descuento != 100)){
                                    this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.sameNoItems[i].No ,false);
                                    return;
                                }
                            }
                        } else {            
                                this.items[this.editedIndex].cantidad = this.editedItems[0].cantidad;*/
                                this.commitToCart(this.sameNoItems[i],false);   
                            }     
                        }
                    if (closeDialog) this.dialog = false;
                    if (callback) callback();
                }
            });
            if (!ok) return;
            
        },   
        deleteItem (item) {
            const index = this.orderItems.indexOf(item);            
            const indexSame = this.sameNoItems.indexOf(item);   
            if (confirm('¿Desea eliminar el producto? No se puede deshacer')){
                this.orderItems.splice(index, 1);                
                this.sameNoItems.splice(indexSame, 1);
                this.sameNoItemsBackup.splice(indexSame, 1);
            }
        },
        addNew(){            
            //Deep copy
            var newline = JSON.parse(JSON.stringify(this.editedItems[0]));
            newline.cantidad = 0;
            //newline.precio = 0;
            newline.descuento = 0;
            newline.lote = '';
            this.editedItems.push(Object.assign({}, newline));
        },
        next(){                        
            if (this.editedIndex+1 < this.items.length){                                
                this.openDialog(this.items[this.editedIndex+1])
            }
        },
        previous(){
            if (this.editedIndex-1 >= 0){                                
                this.openDialog(this.items[this.editedIndex-1])
            }
        }
    },    
    computed: {   
         isFullscreen:{
            get(){
                if (this.windowSize.x <= 960){
                    return true;
                } else {
                    return false;
                }
            }
        },
        maxImgHeight:{
            get(){
                if (this.windowSize.x <= 960){
                    return 200;
                } else {
                    return 550
                }
            }
        },
        errors:{
            get(){
                return errors.first('dto');
            }
        },
        items:{
            get(){
                return this.$store.state.items;
            },
            set(value){
                this.$store.commit('setItems',value);
            }
        },
        orderItems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        dialog:{
            get(){
                return this.$store.state.dialogEditItem;
            },
            set(value){
                this.$store.state.dialogEditItem = value;
            }
        },
        dialogData:{
            get(){
                return this.$store.state.dialogData;
            },
            set(value){
                this.$store.state.dialogData = value;
            }
        },
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        },
        editedIndex:{
            get(){
                return this.$store.state.editedIndex;
            },
            set(value){
                this.$store.state.editedIndex = value;
            }
        },
        sameNoItems:{
            get(){
                return this.$store.state.sameNoItems;
            },
            set(value){
                this.$store.state.sameNoItems = value;
            }
        },        
        sameNoItemsBackup:{
            get(){
                return this.$store.state.sameNoItemsBackup;
            },
            set(value){
                this.$store.state.sameNoItemsBackup = value;
            }
        },
        windowSize:{
            get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
        },
        totalAvailable:{
            get(){
                var total = 0;
                this.$store.state.Available.forEach(av => {
                    total += av.QtyAvailable;
                });
                return total.toFixed(2);
            }
        },
        availabilityListVisible: {
            get(){
                return this.$store.state.availabilityListVisible;
            },
            set(value){
                this.$store.state.availabilityListVisible = value;
            }
        },
    } 
}
</script>
<style scoped>
li {
    list-style-type: none;
}
.btnright{
    position: absolute;
    top: 175px;
    right: 0;
    z-index: 100;
}
.btnleft{
    position: absolute;
    top: 175px;    
    z-index: 100;
}
.btnsave{
    position: fixed;
    top: 15px;    
    right: 10px;
    z-index: 100;
}
.btncancel{
    position: fixed;
    top: 15px;   
    right: 70px; 
    z-index: 100;
}
.bold-text{
    font-weight: bold;
}
.priceTag{
    font-size: 15px;
    font-weight: bold;
    margin-top: 15px;
}
.stickyHeader{
    position: fixed;
    width: 100%;
    z-index: 1;
}
</style>